import { SelectableCard } from './SelectableCard';
import { StepHeading, StepHelperText } from './StepText';

interface ProjectScopeOption {
    value: string;
    label: string;
}

/**
 * Mirrors `BuildHubStageConfigService` residential + commercial scopes. Slugs
 * are stored on the submission so they match BuildHub exactly — required by
 * the matcher step. Internal (ArchiPro-staff-only) scopes are excluded.
 */
export const PROJECT_SCOPE_OPTIONS: ProjectScopeOption[] = [
    { value: 'new-home-build', label: 'New Home Build' },
    { value: 'home-renovation', label: 'Home Renovation' },
    { value: 'extension-addition', label: 'Home Extension' },
    { value: 'interior-fitout', label: 'Interior Fit-Out' },
    { value: 'landscaping-outdoor', label: 'Landscaping' },
    { value: 'pool-spa', label: 'Pool or Spa Installation' },
    { value: 'new-commercial-build', label: 'New Commercial Build' },
    { value: 'fitout-refurbishment', label: 'Fit-Out / Refurbishment' },
    { value: 'hospitality', label: 'Hospitality' },
    { value: 'retail-showroom', label: 'Retail / Showroom' },
    { value: 'office-workplace', label: 'Office / Workplace' },
    { value: 'multi-unit-development', label: 'Multi-Unit Development' },
];

/** Slug → label lookup for rendering stored values in admin / tracking / email. */
export const PROJECT_SCOPE_LABELS: Record<string, string> = Object.fromEntries(
    PROJECT_SCOPE_OPTIONS.map((o) => [o.value, o.label]),
);

interface Step4ProjectScopeProps {
    value: string | null;
    onSelect: (slug: string) => void;
}

export const Step4ProjectScope = ({
    value,
    onSelect,
}: Step4ProjectScopeProps) => {
    return (
        <div className="flex flex-col gap-[1.375rem]">
            <StepHeading>Project scope</StepHeading>
            <StepHelperText>
                Pick the closest match — this is how we group projects across
                the platform.
            </StepHelperText>
            <ul className="flex flex-col gap-2">
                {PROJECT_SCOPE_OPTIONS.map((option) => (
                    <li key={option.value}>
                        <SelectableCard
                            title={option.label}
                            selected={value === option.value}
                            onClick={() => onSelect(option.value)}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};
